import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import TabNavigation from '../../../components/organisms/tab-navigation';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

const Movement = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();

	const options: { label: string; path: string }[] = [
		{
			label: t('movement.auto.title'),
			path: '/movement/auto',
		},
		{
			label: t('movement.manual.title'),
			path: '/movement/manual',
		},
	];

	useEffect(() => {
		if (location.pathname.split('/').length <= 2) navigate(options[0].path);
	}, [location]);

	return (
		<div className="flex flex-col flex-grow bg-white rounded-lg shadow-md">
			<TabNavigation options={options} />
			<Outlet />
		</div>
	);
};

export default Movement;
